<template>
	<b-container class="show-document">
		<div class="actions mb-2 mt-2 hidden-print">
			<div>
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
					$t('back') }}
				</b-button>
			</div>
		</div>
		<b-card class="mt-3 p-3">
			<div class="text-center mt-3">
				<h3 class="font-weight-bold text-uppercase">{{$t(newDocument.documentType)}} №: <span class="small">{{newDocument.regNumber}}</span>
				</h3>
			</div>
			<div id="tableTopActions" class="d-flex justify-content-end align-items-center">
				<!-- <div>
					<b-form-group class="pull-right mb-0">
						<b-form-radio-group
							id="btn-radios-2"
							v-model="countType"
							:options="types"
							buttons
							button-variant="outline-primary"
							size="sm"
							name="radio-btn-outline"
						></b-form-radio-group>
					</b-form-group>
					<div class="clearfix"></div>F
				</div> -->
				<div class="actions mb-2">
					<b-container>
						<b-row>
							<b-col cols="12" class="text-right">
								<!-- <b-button @click="pendingModal = !pendingModal" variant="outline-warning"
										  class="ml-2">
									Возврат
								</b-button>
								<b-button @click="openReturnItems" variant="outline-warning" class="ml-2">Возврат
									Товар
								</b-button>
								<b-button @click="spisatModal = !spisatModal" variant="outline-danger" class="ml-2">
									{{
									$t('pending.off') }}
								</b-button>
								<b-button @click="showAdjustmentModal" variant="outline-primary" class="ml-2">
									Регулировать
								</b-button> -->
								<b-button @click="checkAndSave" variant="success"
										  class="ml-2">{{ $t('pending.save') }}
								</b-button>
							</b-col>
						</b-row>
					</b-container>
				</div>
			</div>
			<b-table :fields="columns" :items="packListItems" class="verticalAlignMiddle" striped>
				<template slot="number" slot-scope="data">
					<strong>{{ data.index + 1}}</strong>
				</template>
				<template slot="quantity" slot-scope="data">
					{{ parseFloat(data.item.quantity - data.item.accepted_quantity) }}
				</template>
				<template slot="accepted_quantity" slot-scope="data">
					<div class="w-75p">
						<b-input-group size="sm">
							<b-input type="number" @keyup="keyup(data.index)"
									 :disabled="isBarcode"
									 @focus="$event.target.select()"
									 v-model="accepted[data.index].accepted_quantity"
									 min="0"
									 size="sm"></b-input>
							<b-input-group-addon>
								<b-button disabled size="sm">{{data.item.unit_name}}</b-button>
							</b-input-group-addon>
						</b-input-group>
					</div>
				</template>
			</b-table>
			<!-- <table class="table table-bordered mt-3">
				<thead>
				<tr>
					<th class="alignCenter">№</th>
					<th>Товар</th>
					<th class="alignCenter">{{ $t('incomes.create.count')}}</th>
					<th class="alignCenter">{{ $t('incomes.create.count')}}</th>
				</tr>
				</thead>
				<tr v-for="income,index in packListItems">
					<td class="alignCenter">
						{{ index + 1 }}
					</td>
					<td>
						{{income.name ? income.name.substring(0, 20) : '' }} / <strong>{{ income.model_no
						}}</strong> / {{ income.color_code }} / {{ income.size ? income.size.name : ' ' }} /
						<strong>{{ income.barcode }}</strong>
					</td>
					<td class="alignCenter">
						{{ income.accepted_quantity ? income.quantity - income.accepted_quantity : income.quantity }} {{income.unitName}}
					</td>
					<td class="w-300"> -->
						<!-- <span class="w-24p text-center">
							<span class="text-danger" v-if="accepted[index] ? accepted[index].changed : false && checkIsKam(index)"><i
								class="fa fa-question-circle"></i></span>
							<span class="text-danger" v-if="accepted[index] ? accepted[index].changed : false && checkIsKop(index)"><i
								class="fa fa-question-circle"></i></span>
							<span class="text-success" v-if="accepted[index] ? accepted[index].changed : false && checkIsTeng(index)">
								<i class="fa fa-check"></i>
							</span>
						</span> -->
						<!-- <div class="w-75p">
							<b-input-group size="sm">
								<b-input type="number" @keyup="keyup(index)"
										 :disabled="isBarcode"
										 @focus="$event.target.select()"
										 v-model="accepted[index].accepted_quantity"
										 min="0"
										 size="sm"></b-input>
								<b-input-group-addon>
									<b-button disabled size="sm">{{income.unit_name}}</b-button>
								</b-input-group-addon>
							</b-input-group>
						</div>
					</td>
				</tr>
			</table> -->
			<div v-if="loading" class="spinner-wrapper">
				<b-spinner variant="primary"></b-spinner>
			</div>

		</b-card>
		<b-modal size="md" v-model="confirmModal" hide-footer>
			<div slot="modal-title">
				{{ $t('pending.confirm')}}
			</div>
			<div>
				<div v-if="isSpisat">
					<div>
						<b-form-group :label="$t('comment')">
							<b-textarea v-model="comment"></b-textarea>
						</b-form-group>
					</div>
					<div class="text-right">
						<b-button @click="shortage(true)" class="mr-2">{{ $t('pending.done') }}</b-button>
					</div>
				</div>
				<b-row v-if="!isSpisat" class="text-center">
					<b-col cols="6">
						<b-button block variant="danger" @click="isSpisat = true" class="mr-2">{{ $t('pending.off') }}
						</b-button>
					</b-col>
					<b-col cols="6">
						<b-button block variant="warning" @click="shortage(false)">{{ $t('pending.wait') }}</b-button>
					</b-col>
				</b-row>
			</div>
		</b-modal>
		<!-- <b-modal
			:hide-footer="true"
			title="Регулировать"
			@close="adjustmentModal = false"
			size="xl"
			v-model="adjustmentModal">
			<div v-if="adjustmentModal">
				<adjustment
					:document-id="item.id"
					@ok="adjustment"
					@cancel="adjustmentModal = false"
					:items="collectAdjustment"></adjustment>
			</div>
		</b-modal>
		<b-modal
			:hide-footer="true"
			@close="spisatModal = false"
			title="Списать"
			size="xl"
			v-model="spisatModal">
			<div v-if="spisatModal">
				<spisat
					:document-id="item.id"
					@cancel="spisatModal = false"
					@ok="spisatAction"
					:items="collectAdjustment"></spisat>
			</div>
		</b-modal> -->

		<b-modal
			v-model="waitModal"
			@ok="checkAndSave('wait')"
			ok-title="Да"
			cancel-title="Отмена"
		>
			<h4>Принимать и ждать?</h4>
		</b-modal>
		<b-modal
			v-model="pendingModal"
			@ok="returnPending"
			ok-title="Да"
			cancel-title="Отмена"
		>
			<h4>Возврат?</h4>
		</b-modal>

		<b-modal
			:hide-footer="true"
			title="Возврать товар"
			v-model="openReturnItemModal"
			@ok="returnPending"
			size="xl"
		>

			<div v-if="openReturnItemModal">
				<ReturnItems
					:document-id="item.id"
					@cancel="closeReturnModal"
					@ok="returnItems"
					:items="collectReturnITems">
					<h4>Возврат?</h4>
				</ReturnItems>
			</div>
		</b-modal>


	</b-container>
</template>

<script>
	import WhDocument from "../../../../services/wh-document.service";
	import GoodsService from "../../../../services/goods.service";
	import {TokenService} from "../../../../services/storage.service";
	import Adjustment from "./blocks/Adjustment";
	import Spisat from "./blocks/Spisat";
	import ReturnItems from "./blocks/ReturnItems";
	import {mapActions, mapState} from 'vuex'

	export default {
		name: 'Pending',
		components: {Adjustment, Spisat, ReturnItems},
		data() {
			return {
				item: {},
				accepted: [],
				incomes: [],
				countType: 'Ручной',
				types: ['Штрихкод', 'Ручной'],
				hasShortage: false,
				moreCount: false,
				confirmModal: false,
				waitModal: false,
				adjustmentModal: false,
				spisatModal: false,
				pendingModal: false,
				isSpisat: false,
				comment: null,
				openReturnItemModal: false,
				documentId: null,
				adjustmentItem: {},
				spisatItems: [],
				returnItemsArray: [],
				loading: false
			}
		},

		methods: {
			goBackToFrom() {
				this.$router.back();
			},
			closeReturnModal() {
				this.openReturnItemModal = false;
			},
			openReturnItems() {
				this.openReturnItemModal = true;
			},
			...mapActions('warehouse', [
				'returnPendingAction', 'getPackListAction',
				'receivePendingIncome', 'createWhDoc',
				'acceptByManufacturer', 'getWhDocById',
				'checkPendingIncomeItems'
			]),

			/**
			 *
			 * @returns {*}
			 */

			async get() {
				if (this.$can('get', 'warehouse-document')) {
				    this.loading = true;
						await this.getPackListAction(this.$route.params.id);
						if (this.packListItems !== undefined) {
								this.accepted = JSON.stringify(this.packListItems.slice());
								this.accepted = JSON.parse(this.accepted).map(this.resetCount)
								this.accepted.map(item => {
									item.accepted_quantity = null;
									return item;
								})
						}
						this.loading = false;
				}
				// return WhDocument.get(this.$route.params.id).then(response => {
				// 	this.item = response.data;
				// 	if (this.item.documentStatus === 'READY') {
				// 		this.$router.push(`/warehouse-management/transfers`)
				// 	}
				// 	this.incomes = this.item.whItems;
				// 	if (this.incomes !== undefined) {
				// 		this.accepted = JSON.stringify(this.incomes.slice());
				// 		this.accepted = JSON.parse(this.accepted).map(this.resetCount)
				// 	}
        //             this.loading = false;
				// }).catch(error => {
        //             this.loading = false
        //         })
			},

			getReturn() {
				return WhDocument.get(this.$route.params.id).then(response => {
					this.item = response.data;
					if (this.item.documentStatus === 'READY') {
						this.$router.push(`/warehouse-management/transfers`)
					}
					this.incomes = this.item.whItems;
					if (this.incomes !== undefined) {
						this.accepted = JSON.stringify(this.incomes.slice());
						this.accepted = JSON.parse(this.accepted).map(this.resetCountVozvrat)
					}
            this.loading = false;
          }).catch(error => {
				    this.loading = false
				})
			},
			/**
			 *
			 */
			keyup(index) {
				this.accepted[index].changed = true
			},

			/**
			 *
			 * @param item
			 * @returns {*}
			 */

			resetCount(item) {
				item.changed = false;
				// item.count = 0;
				return item;
			},
			resetCountVozvrat(item) {
				item.changed = false;
				return item;
			},
			/**
			 *
			 * @param barcode
			 */
			// onBarcodeScanned(barcode) {
			// 	if (this.isBarcode) {
			// 		GoodsService.byBarcode(barcode).then(response => {
			// 			const income = this.findIncome(response);
			// 			if (income) {
			// 				this.accepted[this.incomes.indexOf(income)].count++;
			// 				this.accepted[this.incomes.indexOf(income)].changed = true;
			// 			}
			// 		})
			// 	}

			//},

			/**
			 *
			 * @param response
			 */
			findIncome(response) {
				return this.incomes.find((item) => {
					if (item.itemId === response.id) {
						return item;
					}
				})
			},

			/**
			 *
			 */
			checkIsKam(index) {
				return (this.incomes[index].accepted_quantity > this.accepted[index].quantity);
			},

			/**
			 *
			 */
			checkIsKop(index) {
				return (this.incomes[index].accepted_quantity < this.accepted[index].quantity);
			},

			checkIsTeng(index) {
				return this.incomes[index].accepted_quantity === parseInt(this.accepted[index].quantity);
			},

			async checkAndSave(typeString) {
				if (typeString == 'wait') {
					this.shortage(false)
				} else {
					this.hasShortage = false;
					this.moreCount = false;
					await this.checkShortage();
					if (this.moreCount) {
						this.$vs.notify({
							title: 'Неверное количество товаров!',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						return 0;
					}
					if (!this.hasShortage) {
						// delete this.item.whItems;
						// WhDocument.update(this.item).then(() => {
						// 	this.$router.push(`/warehouse-management/income/view/${this.item.id}`);
						// })
					} else {
						this.waitModal = true
					}
				}
			},

			/**
			 * Check shortages
			 */
			checkShortage() {
				this.accepted.map((item, index) => {
					item.changed = true
					if (parseInt(item.accepted_quantity) > this.packListItems[index].quantity) {
						this.moreCount = true;
					}
					if (parseInt(item.accepted_quantity) !== this.packListItems[index].quantity) {
						this.hasShortage = true;
					}
				});
			},

			/**
			 * Confirm modal
			 */
			showAdjustmentModal() {
				this.adjustmentModal = true;
			},

			/**
			 *
			 */
			adjustment($event) {
				this.adjustmentItem = $event
				this.adjustmentModal = false
				if (this.adjustmentItem) {
					WhDocument.adjustmentAdd(this.adjustmentItem).then(response => {
						this.get();
						this.adjustmentModal = false;
					})
				}
			},

			spisatAction($event) {
				this.spisatItems = $event
				if (this.spisatItems) {
					WhDocument.spisat(this.$route.params.id, this.spisatItems).then((response) => {
						this.get();
						this.spisatModal = false;
					});
				}
			},
			returnItems($event) {
				this.returnItemsArray = [];
				for (let i = 0; i < $event.length; i++) {
					if ($event[i].qty > 0) {

						$event[i].accepted_quantity = $event[i].qty;
						this.returnItemsArray.push($event[i]);
					}

				}

				if (this.returnItemsArray) {
					WhDocument.returnItemsService(this.$route.params.id, this.returnItemsArray).then((response) => {
						this.getReturn();
						this.openReturnItemModal = false;
					});
				}
			},

			/**
			 * Shortage
			 */
			async shortage(spisat = false) {
				// WhDocument.partial(this.item.id, this.collectShortage).then((data) => {
				// 	if (!spisat) {
				// 		this.$router.push(`/warehouse-management/transfers`);
				// 	} else {
				// 		this.documentId = data[0].documentId;
				// 		this.spisat(data[0].documentId)
				// 	}
				// })
				let temp = this.accepted.filter(item => {
					if (item.accepted_quantity > 0) {
						return item;
					}
				})
				await this.checkPendingIncomeItems(temp);
				await this.receivePendingIncome(temp);
				await this.acceptByManufacturer(this.makeAcceptPayload);
			},

			spisat(documentId) {
				WhDocument.spisat(documentId, {comment: this.comment}).then((response) => {
					this.isSpisat = false;
					this.comment = null;
					this.confirmModal = false;
					this.adjustmentModal = true;
				})
			},

			fullScreen() {
				// const elem = document.documentElement;
				// elem.requestFullscreen();
			},
			exitFullScreen() {
				// document.exitFullscreen();
			},
			async returnPending() {
				await this.returnPendingAction(this.$route.params.id);
				this.openReturnItemModal = false;
				this.$router.back();
			},

		},

		computed: {
			...mapState('warehouse', [
				'packListItems', 'newDocument', 'currentPackDocId'
			]),
			columns() {
				return [
					{
						key: 'number',
						label: '№',
						visible: true,
						changebale: false,
						class: 'textAlignCenter'
					},
					{
						key: 'name',
						label: this.$t('goods.name'),
						visible: true,
						changebale: false,
						class: 'textAlignCenter'
					},
					{
						key: 'model_no',
						label: this.$t('goods.artikul'),
						visible: true,
						changebale: false,
						class: 'textAlignCenter'
					},
					{
						key: 'color_name',
						label: this.$t('goods.color'),
						visible: true,
						changebale: false,
						class: 'textAlignCenter'
					},
					{
						key: 'size_name',
						label: this.$t('goods.size'),
						visible: true,
						changebale: false,
						class: 'textAlignCenter'
					},
					{
						key: 'unitName',
						label: this.$t('goods.create.unit'),
						'class': 'td-30 textAlignCenter',
						visible: false,
						changebale: true
					},
					{
						key: 'quantity',
						label: this.$t('incomes.create.count'),
						visible: true,
						changebale: false,
						class: 'w-300 textAlignCenter',
						width: '18%',
					},
					{
						key: 'accepted_quantity',
						label: 'Принимающее количество',
						visible: true,
						changebale: false,
						class: 'textAlignCenter width20_wordBreak'
					},
					// {
					// 	key: 'actions',
					// 	label: this.$t('actions.title'),
					// 	visible: true,
					// 	changebale: false,
					// 	class: 'textAlignCenter table_actions'
					// },
				]
			},
			/**
			 * checkIfBarcode
			 * @returns {boolean}
			 */
			isBarcode() {
				return this.countType === 'Штрихкод';
			},
			collectShortage() {
				let items = [];

				this.accepted.map((item, index) => {
					if (this.checkIsKam(index) || this.checkIsKop(index)) {
						items.push({
							id: item.id,
							qtyFull: this.incomes[index].quantity,
							qtyLow: parseInt(item.accepted_quantity)
						})
					}
				});
				return items;
			},
			makeAcceptPayload() {
				let payload = {
					pack_id: this.$route.params.id,
					doc_number: this.newDocument.regNumber,
					items: this.accepted.map(item => {
						let newItem = {
							id: item.id,
							accepted: item.accepted_quantity
						}
						return newItem;
					})
				}
				return payload;
			},


			/**
			 *
			 * @returns {Array}
			 */
			collectAdjustment() {
				const items = [];

				this.accepted.map((item, index) => {
					if (this.checkIsKam(index) || this.checkIsKop(index)) {
						items.push({
							itemId: item.itemId,
							itemName: item.itemName,
							barcode: item.barcode,
							artikul: item.artikul,
							size: item.size,
							color: item.color,
							id: item.id,
							qty: 0,
							whDocumentItemId: item.id,
							count: this.incomes[index].count - parseFloat(item.count),
							unit: item.unitName
						})
					}
				});

				return items;
			},
			collectReturnITems() {
				const items = [];

				this.accepted.map((item, index) => {
					if (this.checkIsKam(index) || this.checkIsKop(index)) {
						items.push({
							itemId: item.itemId,
							itemName: item.itemName,
							barcode: item.barcode,
							artikul: item.artikul,
							size: item.size,
							color: item.color,
							id: item.id,
							qty: 0,
							count: this.incomes[index].quantity - parseFloat(item.accepted_quantity),
							unit: item.unitName
						})
					}
				});

				return items;
			},

		},

		async created() {
			this.loading = true;
			if (this.currentPackDocId) {
				await this.getWhDocById(this.currentPackDocId);
			} else {
				await this.createWhDoc(this.newDocument);
			}
			await this.get();
			// this.$barcodeScanner.init(this.onBarcodeScanned);
			// this.fullScreen();

		},

		destroyed() {
			this.exitFullScreen();
		},

		watch: {
			accepted: {
				deep: true,
				handler(newValue) {
					this.hasShortage = false;
					this.accepted.map((item, i) => {
						if (parseInt(item.accepted_quantity) !== this.packListItems[i].quantity && item.changed) {
							this.hasShortage = true;
						}
					})
				}
			}
		}
	}
</script>

<style scoped>
	.w-300 {
		width: 300px;
	}
	.w-75p {
		width: 75%;
		display: inline-block;
	}

	.w-24p {
		width: 24%;
		display: inline-block;
		font-size: 20px;
	}

	.alignCenter {
		text-align: center;
	}
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
